import styled from '@emotion/styled';
import { fontSettings } from '@core/components/Button/types';
import { Image } from '@core/components/Image';
import { THUMBNAIL_HEIGHT, THUMBNAIL_WIDTH } from '@core/styles/cssVariables';
const PLAYER_CARD_HEIGHT_WITH_MULTIPLE_PRODUCTS = '120px';
const PLAYER_CARD_HEIGHT_WITH_SINGLE_PRODUCT = '72px';
export const StyledThumbnailContainerV2 = styled.div `
  position: relative;
  border-radius: var(--border-radius, 11px);
  border: 1px solid var(--player-deck-border-color, #e1e4e8);

  ${({ responsive, columnWidth, minWidth, maxWidth }) => responsive
    ? `
        flex: 0 0 ${columnWidth};
        ${minWidth ? `min-width: ${minWidth}px;` : ''}
        ${maxWidth ? `max-width: ${maxWidth}px;` : ''}
        `
    : `height: var(
    ${THUMBNAIL_HEIGHT},
    calc(
      ${({ height }) => height}px - ${PLAYER_CARD_HEIGHT_WITH_SINGLE_PRODUCT}
    )
  );`}

  background-color: var(--player-deck-list-background, #fff);
  box-sizing: content-box;
  padding-bottom: ${PLAYER_CARD_HEIGHT_WITH_SINGLE_PRODUCT};
`;
export const ThumbnailContainer = styled.div `
  ${({ responsive, height, width }) => responsive
    ? ``
    : `
      height: var(${THUMBNAIL_HEIGHT}, ${height}px);
      width: var(${THUMBNAIL_WIDTH}, ${width}px);
    `}
`;
export const ProductListWrapper = styled.div `
  display: flex;
  flex-direction: column;
  height: ${({ showAllProducts, hasMultipleProducts }) => showAllProducts
    ? '100%'
    : hasMultipleProducts
        ? PLAYER_CARD_HEIGHT_WITH_MULTIPLE_PRODUCTS
        : PLAYER_CARD_HEIGHT_WITH_SINGLE_PRODUCT};
  width: 100%;
  position: absolute;
  bottom: 0;
  border-radius: 0 0 var(--border-radius, 11px) var(--border-radius, 11px);
`;
export const CTAWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 72px;
  width: 100%;
  position: absolute;
  bottom: 0;
`;
export const CTALink = styled.a `
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 0 var(--border-radius, 11px) var(--border-radius, 11px);
  padding: 8px 16px;
  width: 100%;
  height: 100%;
  text-decoration: none !important;
  color: var(--player-deck-cta-button-color);
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
  font-family: var(--font-family);
  font-size: var(--button-font-size, ${fontSettings.default}px);
  font-weight: var(--button-font-weight, 600);
  background-color: var(--player-deck-cta-background-color);
`;
export const LivestreamCTA = styled.button `
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 0 var(--border-radius, 11px) var(--border-radius, 11px);
  padding: 8px 16px;
  width: 100%;
  height: 100%;
  color: var(--player-deck-cta-button-color);
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
  font-family: var(--font-family);
  font-size: var(--button-font-size, ${fontSettings.default}px);
  font-weight: var(--button-font-weight, 600);
  background-color: var(--player-deck-cta-background-color);
  border: none;
`;
export const ToggleButtonContainer = styled.div `
  display: flex;
  justify-content: flex-end;
  padding: 8px 17px;
  height: 48px;
`;
export const ProductList = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  color: black;
  gap: 2px;
  border-radius: 0 0 var(--border-radius, 11px) var(--border-radius, 11px);
  overflow: auto;
  background-color: var(--player-deck-list-background, #fff);
  backdrop-filter: blur(4px);
  &::-webkit-scrollbar {
    display: none;
  }
`;
export const ProductCardGrid = styled.div `
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  height: 72px;
  padding: 4px;

  background: var(--player-deck-item-background);
  backdrop-filter: blur(15px);

  &:hover,
  &:focus-within {
    background: var(--player-deck-item-background-hover);
  }
`;
export const ProductLink = styled.a `
  text-decoration: none !important;
  color: var(--player-deck-product-card-font-color) !important;
  font-size: var(--player-deck-product-card-font-size, 12px);
  width: ${({ withAddToCart }) => withAddToCart ? 'calc(100% - 60px)' : '100%'};
`;
export const ProductCard = styled.div `
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
  align-items: stretch;
`;
export const ProductImage = styled(Image) `
  height: 64px;
  object-fit: var(--product-card-image-object-fit);
  object-position: 50% 50%;
  border-radius: 6px;
  max-width: 33%;
`;
export const ContentWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 6px;
`;
export const ProductTitle = styled.div `
  font-weight: var(--player-deck-product-card-font-weight, 500);
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
export const CustomProductPriceStyle = styled.span `
  font-family: var(--product-price-font-family, inherit);
  color: var(--product-price-font-color, inherit);
`;
export const PriceWrapper = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
`;
export const Price = styled.div `
  font-weight: var(--player-deck-product-card-font-weight, 600);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const OriginalPrice = styled.span `
  font-weight: var(--player-deck-product-card-font-weight, 500);
  // by default card font size is 12px and og price is 10px
  // 10 / 12 = .833
  font-size: 0.833em;
  opacity: 0.65;
  text-decoration: line-through;
`;
export const DiscountPercent = styled.span `
  font-weight: var(--player-deck-product-card-font-weight, 500);
  color: var(
    --player-deck-product-card-discount-price-font-color,
    #b60000
  ) !important;
  align-self: flex-end;
`;
export const IconButton = styled.button `
  background: var(--player-deck-product-drawer-trigger-background, #fff);
  border-radius: 50%;
  box-sizing: border-box;
  color: var(--player-deck-product-drawer-trigger-foreground, #000) !important;
  width: 32px;
  height: 32px;
  border: 0px;
  cursor: pointer;
  box-shadow: 0px 1px 4px 0px #00000033;
`;
export const SoldOutLabel = styled.span `
  font-size: 13px;
  font-weight: 600;
`;
